import SpringSlider from './SpringSlider'
export { config } from 'react-spring'
export default SpringSlider
